import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=38d7355a&scoped=true"
import script from "./CustomField.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7355a",
  null
  
)

export default component.exports